// Coordenadas en puntos del Word exportado en A4, con un bloque por responsable.
export const anexoUpdatedFields = (fields) => {
  const positions = {
    student_dni: [100, 164, 140],
    authorized_1_name: [201, 452, 335],
    authorized_1_dni: [115, 477, 89],
    authorized_1_phone: [304, 477, 125],
    authorized_2_name: [201, 502, 335],
    authorized_2_dni: [115, 528, 89],
    authorized_2_phone: [307, 528, 129],
    transport_name: [190, 553, 284],
    transport_driver: [199, 578, 328],
    transport_dni: [115, 604, 89],
    transport_phone: [304, 604, 148],
    guardian_clarification: [280, 646, 245],
    guardian_relationship: [215, 696, 305],
  };
  const updated = fields.map((field) => {
    const position = positions[field.id];
    return position
      ? {
          ...field,
          x: position[0],
          top: position[1],
          width: position[2],
          height: 13,
          fontSize: 11,
          previewClear: ['student_name_first_line', 'student_dni'].includes(field.id),
        }
      : field;
  });
  return [
    ...updated,
    {
      ...updated.find((field) => field.id === 'guardian_clarification'),
      id: 'guardian_2_clarification',
      label: 'Aclaración y DNI del responsable 2',
      top: 735,
    },
    {
      ...updated.find((field) => field.id === 'guardian_relationship'),
      id: 'guardian_2_relationship',
      label: 'Carácter de la representación (Padre / Madre) del responsable 2',
      top: 785,
    },
  ];
};
